// @ts-nocheck
import "../instrumentation";
import * as Sentry from '@sentry/react';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/carousel/styles.css';

import {useState, useEffect, useRef, useMemo} from 'react';
import ToastContext from '@/utils/toast-context';
import '@progress/kendo-theme-material/dist/all.css';
import '../theme/kendo/kendo.css';
import '../theme/material/material-ui.css';
import '../theme/loader.css';
import '../theme/global.css';
import '../theme/time-picker.css';
import '../theme/signature-pad.css';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import '../theme/listbox.css';
import '../theme/maps.css';
import Head from 'next/head';
import { useRouter } from 'next/router';
import SubscriptionContext from '@/utils/subscription-context';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import BillingService from '@/services/billing-service';
import useBreakpoint from '@/hooks/useBreakpoint';
import Constants from '@/utils/constants';
import ConfirmAction from '@/components/modals/confirm-action';
import Helper from '@/utils/helper';
import TimerContext from '@/utils/timer-context';
import BusyIndicator from '@/components/busy-indicator';
import BusyIndicatorContext from '@/utils/busy-indicator-context';
import SCMessageBar from '@/components/sc-controls/message-bar/sc-message-bar';
import MessageBarContext from '@/utils/contexts/sc-message-bar-context';
import HubspotContext from '@/utils/contexts/hubspot-context';
import PageContext from '@/utils/page-context';
import { colors, layout } from '@/theme/index';
import Time from '@/utils/time';
import { createTheme, MantineProvider } from "@mantine/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { mantineTheme } from "@/theme/mantineTheme";
import { themeOptions } from "@/theme/material/material-ui";
import '../theme/mantine-overrides.css';
import authenticationService from '@/services/authentication/authentication-service';
import useRefState from '@/hooks/useRefState';
import employeeService from '@/services/employee/employee-service';
import { Notifications } from "@mantine/notifications";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { Provider } from "jotai";
import NewLayout from '@/PageComponents/Layout/Layout';
import AuthProvider from '@/PageComponents/Auth/AuthProvider';
import { ThemeProvider } from "@mui/material";
import PS from '@/services/permission/permission-service';
import { identifyClarityUser } from '@/utils/auth'
import hubspotService from '@/services/hubspot/hubspot-service';
import jobTimerService from '@/services/job/job-timer-service';
import constants from "@/utils/constants";
import {ModalsProvider} from "@mantine/modals";
// Usetiful SDK is dynamically imported on the client to avoid SSR ESM/CJS issues.
import moment from 'moment';
import {useMediaQuery} from "@mantine/hooks";

const maintenanceUrlBase = `https://scgeneraltechstorage.blob.core.windows.net/maintenance/<host>.json`;

// Create QueryClient outside component to maintain single instance across renders
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 5 * 60 * 1000, // 5 minutes - prevents aggressive refetching
      staleTime: 0, // Setting stale time has consequences - many components rely on initial queries to fire each time
      cacheTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false, // Disable refetch on window focus to prevent spam
    },
  },
});

// Export queryClient for use in logout clearing
export { queryClient };

const getPageTitle = (path: any) => {
  if (!path || path === '/') return 'ServCraft';
  const p = path.toLowerCase();
  if (p.startsWith('/job')) return 'Jobs | ServCraft';
  if (p.startsWith('/appointment')) return 'Appointments | ServCraft';
  if (p.startsWith('/query')) return 'Queries | ServCraft';
  if (p.startsWith('/quote')) return 'Quotes | ServCraft';
  if (p.startsWith('/invoice')) return 'Invoices | ServCraft';
  if (p.startsWith('/purchase')) return 'Purchases | ServCraft';
  if (p.startsWith('/customer')) return 'Customers | ServCraft';
  if (p.startsWith('/inventory')) return 'Inventory | ServCraft';
  if (p.startsWith('/report')) return 'Reports | ServCraft';
  if (p.startsWith('/message')) return 'Messages | ServCraft';
  if (p.startsWith('/settings')) return 'Settings | ServCraft';
  return 'ServCraft';
};

function MyApp({ Component, pageProps, pathname, servSidebarState, maintenanceSchedule }: any) {
  const router = useRouter();

  const maintenanceUrlBase = `https://scgeneraltechstorage.blob.core.windows.net/maintenance/<host>.json`;
  const [usingNewComponents, setUsingNewComponents] = useState(false);

  const [toast, setToast] = useState({
    message: 'User created successfully',
    show: false,
  });

  const webFormPathPrefixes = ['/webform'];
  let isWebForm = false;
  webFormPathPrefixes.forEach((path: any) => {
    if (pathname && pathname.indexOf(path) === 0) {
      isWebForm = true;
    }
  });

  const [busyIndicatorText, setBusyIndicatorText] = useState<any>(null);

  const ref = useRef<any>();
  const runningTimerWatchdogMinutes = 1;
  const [lastKnownPosition, setLastKnownPosition] = useState({ x: -1, y: -1, stamp: new Date().valueOf() });

  const customerZone = pathname ? pathname.toLowerCase().indexOf("/customerzone") > -1 : false;
  const tenantZone = pathname ? pathname.toLowerCase().indexOf("/tenantzone") > -1 : false;
  const debitOrderPage = pathname ? pathname.toLowerCase().indexOf("/debit-order") > -1 : false;
  const peachPage = pathname ? pathname.toLowerCase().indexOf("/settings/subscription/peach") > -1 : false;

  const [versionUpgradeAlerted, setVersionUpgradeAlerted] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const refTimer = useRef<any>(null);
  const runningTimer = useRef<any>(null);
  const [subscriptionInfo, setSubscriptionInfo] = useState(Storage.getCookie(Enums.Cookie.subscriptionInfo));
  const [runningTimers, setRunningTimers, getRunningTimersValue] = useRefState([]);

  const [sideBarStateChanged, setSideBarStateChanged] = useState(0);


  const [hasSupplier, setHasSupplier] = useState(Storage.hasCookieValue(Enums.Cookie.supplierID));

  const [timeshiftMilliseconds, setTimeshiftMilliseconds, getTimeshiftMillisecondsValue] = useRefState(-1); // default to -1 to show not initialized, but wont break logic using this value

  // Usetiful load/unload controls based on MasterSystemAdmin permission
  const usetifulLoadedRef = useRef(false);

  const getUsetifulUserTags = () => {
    const userId = Storage.getCookie(Enums.Cookie.userID) || 'ANONYMOUS';
    const fullName = Storage.getCookie(Enums.Cookie.servFullName) || '';
    const emailOrUsername = Storage.getCookie(Enums.Cookie.servUserName) || '';
    let firstName = '';
    let lastName = '';
    if (fullName && typeof fullName === 'string') {
      const parts = fullName.trim().split(/\s+/);
      firstName = parts[0] || '';
      lastName = parts.slice(1).join(' ') || '';
    }
    if (!firstName && emailOrUsername) {
      firstName = emailOrUsername.split('@')[0];
    }
    return {
      userId: String(userId),
      firstName: String(firstName || ''),
      lastName: String(lastName || ''),
    };
  };

  // Derive tenant-related tags for Usetiful (trial/live status and anniversary date)
  const getUsetifulTenantTags = () => {
    try {
      const si = subscriptionInfo || Storage.getCookie(Enums.Cookie.subscriptionInfo) || {};
      // Determine trial vs live status using multiple indicators found in the codebase
      const accessStatus = si?.AccessStatus;
      const customerStatus = si?.CustomerStatus || si?.CustomerStatusEnum;
      const isTrial = accessStatus === Enums.AccessStatus?.Trial
        || customerStatus === 'Trial'
        || customerStatus === Enums?.CustomerStatus?.Trial;

      // Pick the best available anniversary date
      const annivRaw = si?.AnniversaryDate
        || si?.FirstAnniversaryDate
        || si?.SignUpCompleteDate
        // || si?.TrialDate
        // || si?.FirstTrialDate
        || null;

      const tenantAnniversary = annivRaw ? moment(annivRaw).isValid() ? moment(annivRaw).format('YYYY-MM-DD') : null : null;

      return {
        tenantStatus: isTrial ? 'trial' : 'live',
        tenantAnniversary: tenantAnniversary,
      };
    } catch (e) {
      return { tenantStatus: 'live' };
    }
  };

  // Combine user and tenant tags for Usetiful
  const getUsetifulCombinedTags = () => ({
    ...getUsetifulUserTags(),
    ...getUsetifulTenantTags(),
  });

  const initUsetiful = async () => {
    try {
      if (usetifulLoadedRef.current) return;
      const { loadUsetifulScript, setUsetifulTags, } = await import('usetiful-sdk');
      loadUsetifulScript('05e7805ce6a8ee9c1ee4ea1db7158a11');
      setUsetifulTags(getUsetifulCombinedTags());
      usetifulLoadedRef.current = true;
    } catch (e) {
      console.error('Usetiful initialization error', e);
    }
  };

  const updateUsetifulTagsIfLoaded = async () => {
    try {
      if (!usetifulLoadedRef.current) return;
      const { setUsetifulTags } = await import('usetiful-sdk');
      setUsetifulTags(getUsetifulCombinedTags());
    } catch (e) {
      // non-fatal
    }
  };

  // Keep Usetiful tags in sync when subscription info changes (e.g., trial -> live)
  useEffect(() => {
    // only attempt if running in browser
    if (typeof window === 'undefined') return;
    updateUsetifulTagsIfLoaded();
    identifyClarityUser();
  }, [subscriptionInfo]);

  const initUtisfulForNonAdminUsers = async () => {
    if (typeof window === 'undefined') return;
    const hasEmployee = Storage.hasCookieValue(Enums.Cookie.employeeID);
    const superAdminUser = PS.hasPermission(Enums.PermissionName.MasterSystemAdmin);
    if (hasEmployee && !superAdminUser) { // logged in and user is not admin, load usetiful script
      if (!usetifulLoadedRef.current) {
        await initUsetiful();
      } else {
        await updateUsetifulTagsIfLoaded();
      }
    }
  };


  const updateTimeshift = async () => {
    const hasEmployee = Storage.hasCookieValue(Enums.Cookie.employeeID);

    if (hasEmployee) {
      var tsm = await Time.getTimeshiftMilliseconds(false);
      setTimeshiftMilliseconds((tsm as any));
    }
  };

  // const [mobileViewDismissed, setMobileViewDismissed] = useState(Storage.getCookie(Enums.Cookie.mobileViewAlertDismissed) === "true");

  // };

  const getSubscriptionInfo = async (invalidate = false) => {
    // only get subscription if logged in

    if (!subscriptionInfo || currentMaintenanceScheduleRef.current?.showMaintenanceMessage) return;

    const [subscriptionInfoResult, errorMessage] = await BillingService.getSubcriptionInfo(null, invalidate);
    setSubscriptionInfo(subscriptionInfoResult);
    if (errorMessage && errorMessage.length > 0) {
      console.log("GET SUBSCRIPTION INFO ERROR", errorMessage);
    }

    return subscriptionInfoResult;
  }

  let mouse = useRef({ x: -1, y: -1, stamp: new Date().valueOf() });

  const updateMousePosition = (ev: any) => {
    if (mouse.current.x !== ev.clientX || mouse.current.y !== ev.clientY) {
      mouse.current = { x: ev.clientX, y: ev.clientY, stamp: new Date().valueOf() };
    }
  };

  const hubspotTimer = useRef<any>(null);

  async function refreshPermissions() {
    const hasEmployee = Storage.hasCookieValue(Enums.Cookie.employeeID);
    if (checkForInactivity(runningTimerWatchdogMinutes) || !hasEmployee) return;

    await employeeService.refreshPermissions();
  }

  useEffect(() => {
    if (!isWebForm) {
      getSubscriptionInfo();
      checkVersionChange(true);
      updateTimeshift();

      window.addEventListener("mousemove", updateMousePosition);

      refTimer.current = setInterval(async () => {
        // Only update subscription info if it actually changed to prevent unnecessary re-renders
        if (canUpdateSubscriptionInfo()) {
          const cookieSubscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
          // Deep comparison to avoid unnecessary state updates
          if (JSON.stringify(subscriptionInfo) !== JSON.stringify(cookieSubscriptionInfo)) {
            setSubscriptionInfo(cookieSubscriptionInfo);
          }
        }
        checkVersionChange(false);
        await updateTimeshift();
        await authenticationService.updateAPIEndpoint();
        await refreshPermissions();
        await initUtisfulForNonAdminUsers();
      }, 20_000);

      runningTimer.current = setInterval(async () => {
        await updateRunningTimers(false);
      }, 10_000);

      updateRunningTimers(true);
      refreshPermissions();


      initUtisfulForNonAdminUsers();

      clarity(window, document, "clarity", "script", Helper.getClarityID());


      if (!(customerZone || tenantZone || debitOrderPage || peachPage)) {
        let hsDelay = 2000;
        setTimeout(() => {
          console.log(`Loading hubspot...Start`);
          try {
            // loadHubspot();

            hubspotService.loadHubspot();
          } catch (error) {
            console.error(`Loading hubspot...Error ${JSON.stringify(error)}`);
          }
          console.log(`Loading hubspot...End`);
          onHsLoaded(true)
        }, hsDelay);
      }

      hubspotTimer.current = setInterval(() => {
        hubspotVisibility();
      }, 100);
      /** set hubspot alignment **/
      // this works off a watchdog timer to try set the style of the widget to shift left
      hubspotTranformWidget();

      return () => {
        window.removeEventListener("mousemove", updateMousePosition);
        clearInterval(refTimer.current);
        clearInterval(runningTimer.current);
        clearInterval(hubspotTimer.current);
      };
    }

    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild!!!(jssStyles);
    }

  }, []);

    const isUnauthRoute = useMemo(() => {
        if (!pathname) return true;
        const lowerPath = pathname.toLowerCase();
        let prefixPath = constants.PUBLIC_ROUTE_PREFIXES.some((prefix: any) => lowerPath.startsWith(prefix));
        return constants.PUBLIC_ROUTES_EXACT.has(lowerPath) || prefixPath;
    }, [pathname]);

  // Update subscription info when user logs in (route changes from /login to another page)
  useEffect(() => {
    if (!isUnauthRoute) {
      // Check if cookies exist (user is authenticated)
      const token = Storage.getCookie(Enums.Cookie.token);
      if (token) {
        // Update subscription info from cookies immediately after login
        const cookieSubInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (cookieSubInfo && JSON.stringify(cookieSubInfo) !== JSON.stringify(subscriptionInfo)) {
          console.log('Updating subscription info after route change');
          setSubscriptionInfo(cookieSubInfo);
        }
      }
    }
  }, [isUnauthRoute]);

  const hubspotActive = useRef(false);
  const hubspotSize = useRef<any>(null);

  const [hsLoaded, onHsLoaded] = useState(false)

  const setHubspotActive = (val: any) => {
    hubspotActive.current = val;
  };

  const hubspotTranformWidget = () => {

    let interval = null;
    let count = 0;

    interval = setInterval(() => {

      count++;

      let elem = document.getElementById("hubspot-messages-iframe-container");
      if (elem && elem.style) {
        document.querySelector('#hubspot-messages-iframe-container')?.setAttribute('style', `right: 10px !important; transform-origin: 100% 100%; scale: 0.85; display: block;`);
        clearInterval(interval);
      }

      if (count > 50) {
        clearInterval(interval);
      }

    }, 100);

  };

  const hubspotVisibility = () => {
    let elem = document.getElementById("hubspot-messages-iframe-container");
    if (!elem) return;

    if (!elem.style) {
      return;
    }

    let height = parseInt(elem.style.height.replace("px"));

    if (hubspotSize.current === null) {
      hubspotSize.current = height;
    }

    if (hubspotActive.current === true && elem.style.display === "none") {
      elem.style.setProperty('display', 'block', 'important');
      hubspotService.reInitialiseChatWidget();
    } else if (hubspotActive.current === true
      && elem.style.display !== "none"
      && hubspotSize.current && hubspotSize.current === height) {

      window.HubSpotConversations.widget.open!!!();
      hubspotActive.current = false;
    }

    if (hubspotSize.current > height) {
      let fromLogin = sessionStorage.getItem("hubspotFromLogin");
      if (fromLogin && fromLogin === "true") {
        sessionStorage.setItem("hubspotFromLogin", "false");
        hubspotService.reInitialiseChatWidget();
      }
    }

    hubspotSize.current = height;
  };

  const canUpdateSubscriptionInfo = () => {
    const cookie = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (cookie && !subscriptionInfo) {
      return true;
    } else if (cookie && subscriptionInfo) {
      return JSON.stringify(cookie) !== JSON.stringify(subscriptionInfo);
    } else {
      return false;
    }
  }

  const semverGreaterThan = (versionA: any, versionB: any) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
      const a = Number(versionsA.shift());

      const b = Number(versionsB.shift());
      // eslint-disable-next-line no-continue
      if (a === b) continue;
      // eslint-disable-next-line no-restricted-globals
      return a > b || isNaN(b);
    }
    return false;
  };


  const checkVersionChange = async (forceRefresh: any) => {
    try {
      const response = await fetch('/meta.json');
      const meta: { version: string } = await response.json();
      if (forceRefresh) {
        const version = meta.version;
        const isOutOfVersion = version !== Constants.appVersion();
        if (isOutOfVersion) {
          setTimeout(async () => {
            let lastRefresh = window.localStorage.lastRefresh;
            if (!lastRefresh || new Date().valueOf() > parseInt(lastRefresh) + Constants.reloadVersionDebouncePeriodMS) {
              if (caches) {
                let names = await caches.keys();
                for (let name of names) await caches.delete(name);
              }
              console.log("Reloading browser");
              window.localStorage.lastRefresh = new Date().valueOf().toString();
              window.location.reload(true);
            } else {
              console.log("Waiting for cooldown to reload browser");
            }
          }, 100);
        }
      }
    } catch {
      // version check failed — continue to maintenance check below
    }

    try {
      let host = window.location.host;
      let idx = host.indexOf(":");
      if (idx > -1) {
        host = host.substring(0, idx);
      }
      let maintenanceUrl = `${maintenanceUrlBase.replace("<host>", host)}?_=${Math.random()}`;
      let maintenanceResponse = await fetch(maintenanceUrl);
      let maintenanceMeta = await maintenanceResponse.json();
      let newMaintenanceSchedule = maintenanceMeta.maintenanceSchedule;
      newMaintenanceSchedule = autoDismissMaintenanceSchedule(newMaintenanceSchedule);
      if (JSON.stringify(newMaintenanceSchedule) !== JSON.stringify(currentMaintenanceScheduleRef.current)) {
        setMaintenanceShedule(newMaintenanceSchedule);
      }
    } catch (error) {

    }
  };

  const autoDismissMaintenanceSchedule = (newMaintenanceSchedule: any) => {
    if (newMaintenanceSchedule && newMaintenanceSchedule.showMaintenanceWarning) {
      let dismissedId = Storage.getCookie(Enums.Cookie.maintenanceMessageDismissed);
      // FYI if you want to NOT show the message on specific pages, auto dismiss here by checking the pathname
      if (dismissedId === newMaintenanceSchedule.id) {
        newMaintenanceSchedule.showMaintenanceWarning = false;
      }
    }
    return newMaintenanceSchedule;
  }

  const setMaintenanceShedule = (newMaintenanceSchedule: any) => {
    currentMaintenanceScheduleRef.current = newMaintenanceSchedule;
    setCurrentMaintenanceSchedule(() => newMaintenanceSchedule); // used to trigger a rerender
  };

  const breakpoint = useBreakpoint();
  Storage.setCookie(Enums.Cookie.breakpoint, breakpoint);

  const checkForInactivity = (watchdogMinutes: any) => {
    let inactive = false;
    let newStamp = new Date().valueOf();

    if (newStamp > mouse.current.stamp + (1000 * 60 * watchdogMinutes)) {
      inactive = true;
    }

    return inactive;
  };

  const updateRunningTimers = async (force = false) => {

    setHasSupplier(Storage.hasCookieValue(Enums.Cookie.supplierID));
    const hasEmployee = Storage.hasCookieValue(Enums.Cookie.employeeID);

    if (customerZone || tenantZone || !hasEmployee || checkForInactivity(runningTimerWatchdogMinutes) || currentMaintenanceScheduleRef.current?.showMaintenanceMessage) return;

    const timersResult = await jobTimerService.getRunningTimers(force);

    if (JSON.stringify(timersResult) !== JSON.stringify(getRunningTimersValue())) {
      setRunningTimers((timersResult as any));
    }
  }

  const clearRunningTimers = () => {
    setRunningTimers([]);
  }


  const clarity = (c: any, l: any, a: any, r: any, i: any) => {
    if (!i) return;
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
    let t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    let y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);

    setTimeout(() => {
      identifyClarityUser();
    }, 2000);
  };

  const [appointmentPage, setAppointmentPage] = useState('/appointment/scheduler');


  const mobileView = useMediaQuery('(max-device-width: 1023px)');

  const forceMobileFullscreen = useMediaQuery('(max-width: 400px)');


  const [mobileSidebarExpanded, setMobileSidebarExpanded] = useState(false);
  const [tenantName, setTenantName] = useState("");
  const updateTenantName = (newName: any) => {
    if (newName !== tenantName) {
      setTenantName(newName);
    }
  };

  const [messageBarIsActive, setMessageBarIsActive] = useState(false);
  const [messageBarType, setMessageBarType] = useState<any>(null);
  const [messageBarMessage, setMessageBarMessage] = useState<any>(null);

  const [currentMaintenanceSchedule, setCurrentMaintenanceSchedule] = useState(maintenanceSchedule);
  const currentMaintenanceScheduleRef = useRef(maintenanceSchedule);

  const dismissMaintenanceSchedule = () => {
    Storage.setCookie(Enums.Cookie.maintenanceMessageDismissed, currentMaintenanceScheduleRef.current.id);
    setMaintenanceShedule({ ...currentMaintenanceScheduleRef.current, showMaintenanceWarning: false });
  };

  const theme = createTheme(mantineTheme)

  if (currentMaintenanceScheduleRef.current?.showMaintenanceMessage) {
    return (
      <div className="layout">
        <div className="column">
          <div className="container">
            <img src="server-maintenance.svg" className="background-image" />
            <div className="floating">
              <img src="/logo-type-blue.svg" />
              <h4>{currentMaintenanceScheduleRef.current.maintenanceMessage}</h4>
            </div>
          </div>
        </div>

        <style jsx>{`
        .layout {
          display: flex;
          margin: 0;
          padding: 0;
          height: 100vh;
        }
        .column {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          overflow: hidden;
        }
        .container {
          background-color: ${colors.background};
          border-top-left-radius: ${layout.bodyRadius};
          flex-grow: 1;
          overflow-y: auto;
          /*BROWER COMPAT*/
          -ms-overflow-style: none;
          //scrollbar-width: none;
          padding: 1rem;
          text-align: center;
        }
        .background-image {
          position: fixed;
          right: 0.5rem;
          bottom: 0.5rem;
          opacity: 0.2;
          height: 4rem;
        }

        .floating {
          margin-top: 50vh;
          transform: translateY(-50%);
        }
      `}</style>
      </div>
    )
  }

  return (
    // <MapContext.Provider value={{map: MapTest({markers}), markers, setMarkers}}>
  <Sentry.ErrorBoundary fallback={<p>An error has occured</p>}>
    <ThemeProvider theme={themeOptions}>
      <HubspotContext.Provider value={{ setIsActive: setHubspotActive, loaded: hsLoaded }}>
        <MessageBarContext.Provider value={{
          isActive: (messageBarIsActive || currentMaintenanceScheduleRef.current?.showMaintenanceWarning), setIsActive: setMessageBarIsActive,
          setMessageBarType: setMessageBarType, setMessage: setMessageBarMessage
        }}>
          <BusyIndicatorContext.Provider value={{ setText: setBusyIndicatorText }}>
            <SubscriptionContext.Provider value={{ subscriptionInfo: subscriptionInfo, setSubscriptionInfo: setSubscriptionInfo, getSubscriptionInfo: getSubscriptionInfo }}>
              <TimerContext.Provider value={{ runningTimers: runningTimers, updateRunningTimers: updateRunningTimers, clearRunningTimers: clearRunningTimers }}>
                <ToastContext.Provider value={{ toast: toast, setToast: setToast }}>
                  <PageContext.Provider value={{
                    appointmentPage, setAppointmentPage, mobileView, mobileSidebarExpanded,
                    setMobileSidebarExpanded, tenantName, updateTenantName, customerZone, tenantZone, timeshiftMilliseconds,
                    setTimeshiftMilliseconds, updateTimeshift, usingNewComponents, sideBarStateChanged, setSideBarStateChanged
                  }}>
                    <MantineProvider
                      theme={theme}
                      withGlobalStyles
                      withNormalizeCss
                    >
                      <Notifications position={'top-center'} />
                      <Provider >
                        <QueryClientProvider client={queryClient}>
                          <ModalsProvider
                              modals={{
                                // jobCardWizard: JobCardWizard,
                              }}
                              modalProps={{
                                size: 'auto',
                                withCloseButton: false,
                                closeOnEscape: true,
                                closeOnClickOutside: true,
                                centered: true,
                                fullScreen: forceMobileFullscreen,
                                overlayProps: {
                                  color: 'var(--mantine-color-scBlue-5)',
                                  blur: 10,
                                  opacity: .55
                                },
                                transitionProps: {
                                  transition: "pop",
                                  exitDuration: 50,
                                  duration: 100,
                                  timingFunction: "ease"
                                },
                                radius: 'sm',
                              }}
                          >
                            <NewLayout pathname={pathname} servSidebarState={servSidebarState}>
                              {/*<Layout pathname={pathname} servSidebarState={servSidebarState}>*/}
                              {
                                // !hasSupplier && !isWebForm && <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/8236184.js"></script>
                              }
                              <Head>
                                <title>{getPageTitle(router.pathname)}</title>
                                {isWebForm && <link rel="stylesheet"
                                                    href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css"
                                                    integrity="sha384-B0vP5xmATw1+K9KRQjQERJvTumQW0nPEzvF6L/Z6nronJ3oUOFUFpCjEUQouq2+l"
                                                    crossOrigin="anonymous" />
                                }
                              </Head>
                              <AuthProvider>
                                <Component {...pageProps} />
                              </AuthProvider>
                              <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />
                              <BusyIndicator text={busyIndicatorText} />
                              {/* <div style={{display: "none"}}><MapTest /></div> */}
                              <SCMessageBar messageBarType={messageBarType} message={messageBarMessage} isActive={messageBarIsActive}
                                            maintenanceSchedule={currentMaintenanceScheduleRef.current} dismissMaintenanceSchedule={dismissMaintenanceSchedule} />
                              {/* {mobileView && !!subscriptionInfo && subscriptionInfo.SetupComplete === true && !mobileViewDismissed ? <>
                        <MobileViewAlert onDismiss={dismissMobileViewAlert} />
                      </> : ""} */}
                              {/*</Layout>*/}
                            </NewLayout>
                          </ModalsProvider>
                        </QueryClientProvider>
                      </Provider>
                    </MantineProvider>
                  </PageContext.Provider>
                </ToastContext.Provider>
              </TimerContext.Provider>
            </SubscriptionContext.Provider>
          </BusyIndicatorContext.Provider>
        </MessageBarContext.Provider>
      </HubspotContext.Provider>
    </ThemeProvider>
    </Sentry.ErrorBoundary>
    // </MapContext.Provider>      
  )
}

export default MyApp;

